import { render } from "./BudgetPatientSection.vue?vue&type=template&id=4ca97b68"
import script from "./BudgetPatientSection.vue?vue&type=script&lang=js"
export * from "./BudgetPatientSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__